import { useState } from "react";
import { obtenerTemaActual, alternarTema } from "../funcionesDatos/tema";

// Botón de modo oscuro/claro. `sobreFondoOscuro` controla el contraste del botón:
// true (default) para vivir sobre un header siempre oscuro (contenedorHeader, bg-dark),
// false para vivir sobre fondo claro (ej: cuerpo del offcanvas móvil, que es blanco).
function ToggleTema({ className = "", sobreFondoOscuro = true }) {
  const [tema, setTema] = useState(() => obtenerTemaActual());

  function manejarClick() {
    setTema(alternarTema());
  }

  const esOscuro = tema === "dark";

  return (
    <button
      type="button"
      onClick={manejarClick}
      className={`btn ${sobreFondoOscuro ? "btn-outline-light" : "btn-outline-secondary"} d-flex align-items-center justify-content-center flex-shrink-0 ${className}`}
      style={{ width: 38, height: 38, borderRadius: "50%", padding: 0 }}
      title={esOscuro ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      aria-label={esOscuro ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
    >
      <i className={`bi ${esOscuro ? "bi-sun-fill" : "bi-moon-stars-fill"}`}></i>
    </button>
  );
}

export default ToggleTema;
